import React from 'react';
import './Projects.css';
import { Project } from '../types';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const PROJECTS_DATA: Project[] = [
    {
        title: "YOLOv8 Object Detection",
        description: "Real-time object detection application built using YOLOv8 and Streamlit. Capable of identifying objects in images and video streams with high accuracy.",
        techUsed: "Python, YOLOv8, Streamlit, ML",
        image: { url: "/yolov8.png" },
        link: "https://github.com/Vink-135/object_detection"
    },
    {
        title: "Nova Assistant",
        description: "A comprehensive voice-controlled assistant built with the MERN stack. Features include opening GitHub/LinkedIn, file management, Amazon search, ChatGPT/Gemini integration, Google search, and more.",
        techUsed: "MERN Stack, Python, Voice Automation",
        image: { url: "/nova-assistant.png" },
        link: "https://github.com/Vink-135/Nova_assistant"
    },
    {
        title: "PDF Research Tool",
        description: "An intelligent research assistant that uses PyPDF and ML to answer any questions based on the content of attached PDF documents.",
        techUsed: "Python, PyPDF, Machine Learning",
        image: { url: "/pdf-research-tool.png" },
        link: "https://github.com/Vink-135/pdf_researcher"
    },
    {
        title: "Sentilyze",
        description: "Sentiment analysis tool that analyzes YouTube videos and Reddit keywords to gauge public opinion and trends.",
        techUsed: "Python, NLP, Sentiment Analysis",
        image: { url: "/sentilyze.png" },
        link: "https://github.com/Vink-135/Sentilyze"
    }
];

const Projects: React.FC = () => {
    return (
        <div className="projects-container">
            <div className="projects-header">
                <h1 className="projects-title domain-heading">My Projects</h1>
                <p style={{ color: '#b3b3b3' }}>A showcase of my technical journey and innovations.</p>
            </div>

            <div className="projects-grid">
                {PROJECTS_DATA.map((project, index) => (
                    <div className="project-card" key={index}>
                        <img
                            src={project.image.url}
                            alt={project.title}
                            className={`project-image ${["PDF Research Tool", "Sentilyze"].includes(project.title) ? "contain-image" : ""} ${["Nova Assistant", "YOLOv8 Object Detection"].includes(project.title) ? "horizontal-image" : ""} ${project.title === "PDF Research Tool" ? "pdf-research-image" : ""}`}
                        />
                        <div className="project-content">
                            <h3 className="project-title">{project.title}</h3>
                            <p className="project-tech">{project.techUsed}</p>
                            <p className="project-description">{project.description}</p>
                            {project.link && (
                                <a
                                    href={project.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="project-link"
                                >
                                    {project.link.includes('github.com') ? (
                                        <>
                                            <FaGithub /> View on GitHub
                                        </>
                                    ) : (
                                        <>
                                            <FaExternalLinkAlt /> View Live Demo
                                        </>
                                    )}
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Projects;
